import { User } from "features/auth/types/user";
import { createContext, useContext } from "react";

type UserContextProps = {
  children: React.ReactNode;
  user: User;
};

const UserContext = createContext<User | undefined>(undefined);

const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within an UserProvider");
  }
  return context;
};

const UserProvider: React.FC<UserContextProps> = ({ children, user }) => {
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

export { UserProvider as default, useUserContext };
